// extracted by mini-css-extract-plugin
export default {"container":"EmailsMenuItem_container__4Yvoc","textContainer":"EmailsMenuItem_textContainer__LUpry","badge":"EmailsMenuItem_badge__SQYFz","active":"EmailsMenuItem_active__aCJyk"};